/**
 * Draws the game background on a Phaser scene.
 *
 * If the "game_background" texture was loaded at boot (from game config), it is
 * drawn cover-scaled (fills the screen while preserving aspect ratio, centred).
 * Otherwise a solid dark-grey rectangle fills the screen as a fallback.
 *
 * Use in create() of any scene that needs the shared background.
 */
export function drawBackground(scene: Phaser.Scene): void {
    const w = scene.cameras.main.width;
    const h = scene.cameras.main.height;

    if (scene.textures.exists("game_background")) {
        const img = scene.add.image(w / 2, h / 2, "game_background");
        const scaleX = w / img.width;
        const scaleY = h / img.height;
        img.setScale(Math.max(scaleX, scaleY));
    } else {
        // 0x2a2a2a — dark grey, readable contrast with white UI text
        scene.add.rectangle(0, 0, w, h, 0x2a2a2a).setOrigin(0, 0);
    }
}
